import React from 'react';
import { CheckCircle2, Target, Eye, Heart, Award, Users, TrendingUp } from 'lucide-react';
import windlasslogo from '../assets/windlass-logo.png';
import atlantacutlerylogo from '../assets/atlantacutlerylogo.jpg';
import Steelcrafts from '../assets/Windlass-Steelcrafts.jpg';
import whoweare from '../assets/whoweare.jpg';

const About = () => {
  const values = [
    {
      icon: Award,
      title: 'Quality Excellence',
      description: 'Uncompromising commitment to precision and quality in every project we undertake.',
    },
    {
      icon: Users,
      title: 'Customer Focus',
      description: 'Building lasting partnerships through responsive service and reliable delivery.',
    },
    {
      icon: TrendingUp,
      title: 'Continuous Innovation',
      description: 'Investing in cutting-edge technology and processes to stay ahead of industry demands.',
    },
    {
      icon: Heart,
      title: 'Integrity',
      description: 'Operating with honesty, transparency, and ethical business practices.',
    },
  ];

  return (
    <div className="min-h-screen pt-20" data-testid="about-page">
      <section className="relative py-20 px-4 sm:px-6 lg:px-8 overflow-hidden" data-testid="about-hero">
        <div className="absolute inset-0">
          <img
            src="https://images.unsplash.com/photo-1581092918484-8313e1f7e8c7?w=1920&q=80"
            alt="About Crow Corporation"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-blue-900/90 to-blue-700/80"></div>
        </div>
        <div className="max-w-7xl mx-auto relative z-10">
          <h1 className="text-4xl sm:text-5xl font-bold text-white heading-font mb-6" data-testid="about-heading">
            About Crow Corporation
          </h1>
          <p className="text-xl text-blue-100 max-w-3xl">
            A legacy of precision manufacturing excellence spanning over five decades.
          </p>
        </div>
      </section>



      <section className="py-16 px-4 sm:px-6 lg:px-8 bg-white" data-testid="company-intro">
        <div className="max-w-7xl mx-auto">
          <div
            className="py-12 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-2xl mb-12 border border-blue-100"
            data-testid="windlass-affiliates"
          >
            <div className="max-w-7xl mx-auto px-6">
              <h2 className="text-2xl font-bold text-gray-900 heading-font mb-3 text-center py-2 pb-8">Part of the Windlass Group</h2>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">

                <div className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-all flex flex-col items-center mt-2">
                  <div className="h-24 flex items-center justify-center mb-4">
                    <img
                      src={windlasslogo}
                      alt="Windlass Engineers"
                      className="max-h-20 object-contain"
                    />
                  </div>
                  <p className="text-base font-bold text-gray-900 text-center">
                    Windlass Engineers & Services Pvt. Ltd.
                  </p>
                  <p className="text-xs text-gray-900 mt-1">
                    Dehradun, India
                  </p>
                </div>

                <div className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-all flex flex-col items-center">
                  <div className="h-24 flex items-center justify-center mb-4">
                    <img
                      src={windlasslogo}
                      alt="Windlass Oilfield"
                      className="max-h-20 object-contain"
                    />
                  </div>
                  <p className="text-base font-bold text-gray-900 text-center">
                    Windlass Oilfield Equipment LLC
                  </p>
                  <p className="text-xs text-gray-900 mt-1">
                    Aweer Dubai, UAE
                  </p>
                </div>
                <div className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-all flex flex-col items-center">
                  <div className="h-24 flex items-center justify-center mb-4">
                    <img
                      src={Steelcrafts}
                      alt="Windlass Steelcrafts"
                      className="max-h-20 object-contain"
                    />
                  </div>
                  <p className="text-base font-bold text-gray-900 text-center">
                    Windlass Steelcrafts
                  </p>
                  <p className="text-xs text-gray-900 mt-1">
                    Dehradun, India
                  </p>
                </div>

                <div className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-all flex flex-col items-center">
                  <div className="h-24 flex items-center justify-center mb-4 mt-2">
                    <img
                      src={atlantacutlerylogo}
                      alt="Atlanta Cutlery"
                      className="max-h-36 object-contain"
                    />
                  </div>
                  <p className="text-base font-bold text-gray-900 text-center">
                    Atlanta Cutlery
                  </p>
                  <p className="text-xs text-gray-900 mt-1">
                    Georgia, USA
                  </p>
                </div>

              </div>
              <div className="flex flex-col md:flex-row items-start md:items-center gap-6 mt-16">

                <div className="flex-1">

                  <p className="text-gray-700 leading-relaxed mb-4">
                    Crow Corporation is proud to be part of <span className="font-semibold text-blue-700">Windlass Group</span>, a distinguished industrial conglomerate established in India in 1942. This acquisition brings together over 80 years of Indian manufacturing heritage with Crow's 55+ years of American precision manufacturing excellence.
                  </p>
                  <p className="text-gray-700 leading-relaxed">
                    The Windlass Group's global expertise in manufacturing, combined with Crow's specialized capabilities, creates a powerful synergy that benefits our customers with enhanced resources, expanded capabilities, and a commitment to world-class quality standards.
                  </p>
                </div>
              </div>
            </div>
          </div>



          <section className="grid lg:grid-cols-2 gap-12 items-center mb-16 mt-16">
            <div>
              <h2 className="text-3xl font-bold text-gray-900 heading-font mb-6">Who We Are</h2>
              <p className="text-gray-600 mb-4 leading-relaxed">
                Founded in 1970, Crow Corporation has established itself as a premier full-service contract manufacturer specializing in custom metal fabrication, precision CNC machining, and turnkey manufacturing solutions.
              </p>
              <p className="text-gray-600 mb-4 leading-relaxed">
                Our 60,000 square foot state-of-the-art facility in Houston, Texas houses a multi-million dollar investment in cutting-edge equipment and technology. From laser cutting and welding to CNC machining and metal stamping, we deliver both short-run and high-volume production with exceptional precision.
              </p>
              <p className="text-gray-600 leading-relaxed">
                We serve diverse industries including Oil & Gas, Wastewater, Alternative Energy, Offshore, Medical, Construction, and Architecture, building lasting partnerships through quality, reliability, and on-time delivery.
              </p>
            </div>
            <div className="relative">
              <img
                src={whoweare}
                alt="Crow Corporation facility"
                className="rounded-2xl shadow-2xl"
                data-testid="about-intro-image"
              />
            </div>
          </section>

          <div className="grid md:grid-cols-2 gap-8 mb-12">
            <div className="relative h-64 rounded-2xl overflow-hidden shadow-lg">
              <img
                src="https://images.unsplash.com/photo-1565008447742-97f6f38c985c?w=800&q=80"
                alt="Advanced manufacturing equipment"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-blue-900/80 to-transparent flex items-end p-6">
                <h3 className="text-white text-xl font-bold heading-font">
                  Advanced Equipment
                </h3>
              </div>
            </div>
            <div className="relative h-64 rounded-2xl overflow-hidden shadow-lg">
              <img
                src="https://images.unsplash.com/photo-1581092921461-eab62e97a780?w=800&q=80"
                alt="Precision machining operations"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-blue-900/80 to-transparent flex items-end p-6">
                <h3 className="text-white text-xl font-bold heading-font">Precision Operations</h3>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 px-4 sm:px-6 lg:px-8 bg-gray-50" data-testid="mission-vision">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-white rounded-2xl p-8 shadow-md">
              <div className="w-14 h-14 bg-blue-100 rounded-lg flex items-center justify-center mb-6">
                <Target className="w-8 h-8 text-blue-700" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 heading-font mb-4" data-testid="mission-heading">Our Mission</h3>
              <p className="text-gray-600 leading-relaxed">
                To deliver precision manufacturing solutions that exceed our clients' expectations through superior craftsmanship, innovative technology, and unwavering commitment to quality. We strive to be the trusted partner for companies seeking reliable, on-time delivery of complex metalworking projects.
              </p>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-md">
              <div className="w-14 h-14 bg-blue-100 rounded-lg flex items-center justify-center mb-6">
                <Eye className="w-8 h-8 text-blue-700" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 heading-font mb-4" data-testid="vision-heading">Our Vision</h3>
              <p className="text-gray-600 leading-relaxed">
                To be recognized as the leading contract manufacturer in precision metalworking, known for pushing the boundaries of manufacturing excellence while maintaining the personal touch and flexibility that sets us apart from larger competitors.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 px-4 sm:px-6 lg:px-8 bg-white" data-testid="core-values">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 heading-font mb-4" data-testid="values-heading">Our Core Values</h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              The principles that guide everything we do at Crow Corporation.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {values.map((value, index) => (
              <div key={index} className="bg-gray-50 rounded-xl p-6" data-testid={`value-${index}`}>
                <div className="w-12 h-12 bg-blue-700 rounded-lg flex items-center justify-center mb-4">
                  <value.icon className="w-6 h-6 text-white" />
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2 heading-font">{value.title}</h3>
                <p className="text-sm text-gray-600 leading-relaxed">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 px-4 sm:px-6 lg:px-8 bg-white" data-testid="heritage-timeline">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 heading-font mb-4">Our Combined Heritage</h2>
            <p className="text-gray-600">Two legacies of manufacturing excellence united</p>
          </div>

          <div className="relative max-w-5xl mx-auto">
            <div className="absolute left-1/2 transform -translate-x-1/2 h-full w-1 bg-blue-200"></div>

            <div className="grid md:grid-cols-2 gap-8">
              <div className="md:text-right">
                <div className="bg-gradient-to-br from-indigo-50 to-blue-50 rounded-2xl p-8 border-2 border-blue-100 shadow-md">
                  <div className="inline-block bg-blue-700 text-white px-4 py-2 rounded-lg font-bold text-lg mb-4">1942</div>
                  <h3 className="text-2xl font-bold text-gray-900 heading-font mb-3">Windlass Group Founded</h3>
                  <p className="text-gray-700 leading-relaxed">
                    Established in India, Windlass Group begins its journey as a pioneering manufacturing conglomerate, building a legacy of quality and innovation.
                  </p>
                </div>
              </div>
              <div className="md:col-start-2"></div>

              <div className="md:col-start-1"></div>
              <div>
                <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-2xl p-8 border-2 border-blue-100 shadow-md">
                  <div className="inline-block bg-blue-700 text-white px-4 py-2 rounded-lg font-bold text-lg mb-4">1970</div>
                  <h3 className="text-2xl font-bold text-gray-900 heading-font mb-3">Crow Corporation Established</h3>
                  <p className="text-gray-700 leading-relaxed">
                    Founded in Houston, Texas, Crow Corporation sets the standard for precision manufacturing and custom metal fabrication in the United States.
                  </p>
                </div>
              </div>

              <div className="md:text-right">
                <div className="bg-gradient-to-br from-indigo-50 to-blue-50 rounded-2xl p-8 border-2 border-blue-100 shadow-md">
                  <div className="inline-block bg-blue-700 text-white px-4 py-2 rounded-lg font-bold text-lg mb-4">Present</div>
                  <h3 className="text-2xl font-bold text-gray-900 heading-font mb-3">United for Excellence</h3>
                  <p className="text-gray-700 leading-relaxed">
                    Crow Corporation joins the Windlass Group family, combining American precision with global manufacturing expertise to serve customers worldwide.
                  </p>
                </div>
              </div>
              <div className="md:col-start-2"></div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 px-4 sm:px-6 lg:px-8 bg-gray-50" data-testid="why-choose">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 heading-font mb-4">Why Choose Crow Corporation?</h2>
            <p className="text-gray-600">Backed by Windlass Group's global manufacturing excellence</p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            <div className="flex items-start space-x-4">
              <CheckCircle2 className="w-6 h-6 text-blue-700 flex-shrink-0 mt-1" />
              <div>
                <h3 className="font-semibold text-gray-900 mb-2">55+ Years of American Excellence</h3>
                <p className="text-sm text-gray-600">Over five decades of metalworking expertise serving demanding industries.</p>
              </div>
            </div>
            <div className="flex items-start space-x-4">
              <CheckCircle2 className="w-6 h-6 text-blue-700 flex-shrink-0 mt-1" />
              <div>
                <h3 className="font-semibold text-gray-900 mb-2">Windlass Group Heritage</h3>
                <p className="text-sm text-gray-600">Part of a global conglomerate with 80+ years of manufacturing legacy since 1942.</p>
              </div>
            </div>
            <div className="flex items-start space-x-4">
              <CheckCircle2 className="w-6 h-6 text-blue-700 flex-shrink-0 mt-1" />
              <div>
                <h3 className="font-semibold text-gray-900 mb-2">State-of-the-Art Facility</h3>
                <p className="text-sm text-gray-600">60,000 sq ft facility with cutting-edge equipment and technology.</p>
              </div>
            </div>
            <div className="flex items-start space-x-4">
              <CheckCircle2 className="w-6 h-6 text-blue-700 flex-shrink-0 mt-1" />
              <div>
                <h3 className="font-semibold text-gray-900 mb-2">Flexible Production</h3>
                <p className="text-sm text-gray-600">From short-run prototypes to high-volume production runs.</p>
              </div>
            </div>
            <div className="flex items-start space-x-4">
              <CheckCircle2 className="w-6 h-6 text-blue-700 flex-shrink-0 mt-1" />
              <div>
                <h3 className="font-semibold text-gray-900 mb-2">Quality Certified</h3>
                <p className="text-sm text-gray-600">ISO certified with rigorous quality control processes.</p>
              </div>
            </div>
            <div className="flex items-start space-x-4">
              <CheckCircle2 className="w-6 h-6 text-blue-700 flex-shrink-0 mt-1" />
              <div>
                <h3 className="font-semibold text-gray-900 mb-2">On-Time Delivery</h3>
                <p className="text-sm text-gray-600">Proven track record of meeting deadlines and commitments.</p>
              </div>
            </div>
            <div className="flex items-start space-x-4">
              <CheckCircle2 className="w-6 h-6 text-blue-700 flex-shrink-0 mt-1" />
              <div>
                <h3 className="font-semibold text-gray-900 mb-2">Comprehensive Services</h3>
                <p className="text-sm text-gray-600">Full turnkey solutions from design through final delivery.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;